module.exports = __webpack_public_path__ + "static/media/desktop-alt-slash.ab115393.svg";